import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
// import Invoice from '@/components/Invoice'
// import MoneyIn from '@/components/MoneyIn'
const MoneyIn = resolve => require(['../components/MoneyIn.vue'], resolve)
const Invoice = resolve => require(['../components/Invoice.vue'], resolve)
const CostAll = resolve => require(['../components/CostAll.vue'], resolve)
const SurveyAll = resolve => require(['../components/SurveyAll.vue'], resolve)
const StaffPer = resolve => require(['../components/StaffPer.vue'], resolve)

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        title: '引导页（不定）'
      },
      component: Index
    },
    {
      path: '/guide',
      name: 'index',
      meta: {
        title: '引导页'
      },
      component: Index
    },
    {
      path: '/moneyIn',
      name: 'moneyIn',
      meta: {
        title: '收入收款'
      },
      component: MoneyIn
    },
    {
      path: '/invoice',
      name: 'invoice',
      meta: {
        title: '税票管理'
      },
      component: Invoice
    },
    {
      path: '/costAll',
      name: 'costAll',
      meta: {
        title: '费用总账'
      },
      component: CostAll
    },
    {
      path: '/surveyAll',
      name: 'surveyAll',
      meta: {
        title: '总体概况'
      },
      component: SurveyAll
    },
    {
      path: '/staffPer',
      name: 'staffPer',
      meta: {
        title: '员工绩效'
      },
      component: StaffPer
    }
  ]
})
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js